import { useContext, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";

/**
 * contexts
 */
import contextItem from "./context-item";

/** ========== */

const Component = ({ children, ...props }) => {
  const ref = useRef(null);
  const [height, setHeight] = useState();
  const { open } = useContext(contextItem);
  /**
   * handle
   */
  const handleHeight = (ref) => {
    setHeight(ref.current && ref.current.scrollHeight);
  };
  useEffect(() => {
    handleHeight(ref);
    window.addEventListener("resize", () => handleHeight(ref));
    return () => {
      window.removeEventListener("resize", () => handleHeight(ref));
    };
  }, [children]);
  return (
    <div
      {...props}
      ref={ref}
      className={`overflow-hidden ${props.className}`}
      style={{
        maxHeight: open ? `${height}px` : `0px`,
      }}
    >
      {children}
    </div>
  );
};

export default Component;

Component.propTypes = {
  children: PropTypes.node.isRequired,
};

/** ========== */
